import script from "./RequestUpdateModalForProductFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUpdateModalForProductFeatures.vue?vue&type=script&setup=true&lang=js"

import "./RequestUpdateModalForProductFeatures.vue?vue&type=style&index=0&id=6962eb48&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6962eb48"]])

export default __exports__